
// js/custom-element/behavior/collapsible-content.js
var CollapsibleContent = class extends OpenableElement {
    constructor() {
      super();
      this.ignoreNextTransition = this.open;
      this.addEventListener("shopify:block:select", () => this.open = true);
      this.addEventListener("shopify:block:deselect", () => this.open = false);
    }
    get animateItems() {
      return this.hasAttribute("animate-items");
    }
    attributeChangedCallback(name) {
      if (this.ignoreNextTransition) {
        return this.ignoreNextTransition = false;
      }
      switch (name) {
        case "open":
          this.style.overflow = "hidden";
          const keyframes = {
            height: ["0px", `${this.scrollHeight}px`],
            visibility: ["hidden", "visible"]
          };
          if (this.animateItems) {
            keyframes["opacity"] = this.open ? [0, 0] : [0, 1];
          }
          // In the food section, if one tab is open, the others close.
          const validParentClasses = ['shopify-section--main-product', 'alone-learning-outcomes__accordion', 'learning-outcomes__accordion'];
          let isInValidSection = false;
          for (const parentClass of validParentClasses) {
            if (this.closest(`.${parentClass}`)) {
              isInValidSection = true;
              break;
            }
          }
          if (isInValidSection && this.open) {
            const parentSection = this.closest(validParentClasses.map(cls => `.${cls}`).join(','));
            if (parentSection) {
              const allCollapsibles = parentSection.querySelectorAll('collapsible-content');
              allCollapsibles.forEach(collapsible => {
                if (collapsible !== this && collapsible.open) {
                  collapsible.open = false;
                }
              });
            }
          }
          this.animate(keyframes, {
            duration: 500,
            direction: this.open ? "normal" : "reverse",
            easing: "cubic-bezier(0.75, 0, 0.175, 1)"
          }).onfinish = () => {
            this.style.overflow = this.open ? "visible" : "hidden";
            if (this.open && window.matchMedia('(max-width: 1100px)').matches) {
              this.scrollToTabTop();
            }
          };
          if (this.animateItems && this.open) {
            this.animate({
              opacity: [0, 1],
              transform: ["translateY(10px)", "translateY(0)"]
            }, {
              duration: 250,
              delay: 250,
              easing: "cubic-bezier(0.75, 0, 0.175, 1)"
            });
          }
          triggerEvent(this, this.open ? "openable-element:open" : "openable-element:close");
      }
    }
    scrollToTabTop() {
      const parent = this.closest(".learning-outcomes");
      if (parent) {
        const rect = this.getBoundingClientRect();
        const scrollTop = window.scrollY + rect.top - 200;
        window.scrollTo({
          top: scrollTop,
          behavior: "smooth",
        });
      }
    }
  };
  window.customElements.define("collapsible-content", CollapsibleContent);
